import { ExpiringCredential } from '@Models';
import { bopsApi } from '@Network';
import { AppDispatch } from '../store';
import { actions } from './credentials.reducer';

const fetchExpiringCredentials = () => {
  return async (dispatch: AppDispatch) => {
    dispatch(actions.fetchExpiringCredentialsRequest());

    try {
      const providerCredentials = await bopsApi.getExpiringCredentials();
      const expiringCredentials: ExpiringCredential[] = providerCredentials.map((cred) => ({
        id: cred.id,
        connector_type: cred.connector_type,
        status: cred.status,
      }));
      dispatch(actions.fetchExpiringCredentialsSuccess({ credentials: expiringCredentials }));
    } catch (error: any) {
      dispatch(
        actions.fetchExpiringCredentialsFailure({
          error: error?.response?.data?.detail || error?.message || 'Unknown error fetching expiring credentials',
        }),
      );
    }
  };
};

/* eslint-disable import/prefer-default-export */
export { fetchExpiringCredentials };
